import React from "react";
import TextFieldInput from "../../components/TextFieldInput";
import { Alert, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useStyles } from "../../components/StrengthIndicator/StrengthIndicator.styles";
import FormLayoutHeader from "../../layoutComponents/FormLayout/FormLayoutHeader";

const EmailVerification = () => {
	const {
		formState: { errors },
		reset,
		control,
		setValue,
	} = useFormContext();
	const styles = useStyles();
	return (
		<div>
			<FormLayoutHeader title="Zapomenuté heslo" />
			<Typography variant="body1" gutterBottom>
				Zadejte váš e-mail. Pošleme vám na něj odkaz pro nastavení nového hesla.
			</Typography>
				<TextFieldInput
					name="email"
					control={control}
					label={
						<Typography variant="h4" className={styles.float}>
							E-mail
						</Typography>
					}
					reset={reset}
					errors={errors}
					defaultValue=""
					placeholder="Zadejte E-mail"
					setValue={setValue}
					tabValue={1}
				/>
			{errors.root?.serverError.type === "ERR_BAD_RESPONSE" && <Alert severity="error">server response message</Alert>}
		</div>
	);
};

export default EmailVerification;
